import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';
import placeholderSrc from 'assets/AndroidInstructions/screenshot_placeholder.png';
import scr6 from 'assets/AndroidInstructions/xiaomi/xiaomi_autostart_1.jpg';
import scr1 from 'assets/AndroidInstructions/xiaomi/xiaomi_battery_1.jpg';
import scr2 from 'assets/AndroidInstructions/xiaomi/xiaomi_battery_2.jpg';
import scr3 from 'assets/AndroidInstructions/xiaomi/xiaomi_battery_3.jpg';
import scr4 from 'assets/AndroidInstructions/xiaomi/xiaomi_battery_4.jpg';
import scr5 from 'assets/AndroidInstructions/xiaomi/xiaomi_battery_5.jpg';
import scr7 from 'assets/AndroidInstructions/xiaomi/xiaomi_recent_1.jpg';
import scr8 from 'assets/AndroidInstructions/xiaomi/xiaomi_recent_2.jpg';
import scr9 from 'assets/AndroidInstructions/xiaomi/xiaomi_recent_3.jpg';
import SliderBlock from '../SliderBlock';
import { AdviceNotSuitable, Common, Divider, Footer, List, ListItem, SamsungDivider, SettingsButton, Text, Title, } from './common';
const messages = defineMessages({
    card1: 'Go to Settings > Apps',
    card2: 'Manage apps',
    card3: 'Search Sweatcoin',
    card4: 'Go to Battery saver',
    card5: 'Select No restrictions',
    card6: 'Go back and allow autostart',
    card7: 'Open Recent Apps',
    card8: 'Long tap on Sweatcoin and press Lock',
    card9: 'Lock icon should appear',
    manage: 'Manage battery settings',
    settings: 'Go to settings',
    autostart: 'Allow autostart',
    lock: 'Lock Sweatcoin as recent app',
    alternative: 'Alternatively try this:',
    remove: 'Remove restrictions',
    security: 'Security',
    battery: 'Battery',
    appBattery: 'App Battery Saver',
    sweatcoin: 'Sweatcoin',
    noRestriction: 'No restriction',
    settings2: 'Settings',
    performance: 'Battery & Performance',
    usage: 'Manage Apps Battery Usage',
    manageApps: 'Manage Apps Battery Usage',
    apps: 'Apps',
    bgSettings: 'Choose “No Restrictions” under Background Settings',
    andAllow: 'and "Allow" under Background Location Settings',
    adjust: 'Adjust power plan',
    advanced: 'Advanced Settings',
    batManager: 'Battery Manager',
    setPower: 'Set Power plan to Performance, set Sweatcoin as Protected app',
    protected: 'Protected apps – Sweatcoin needs to be Protected',
    enable: 'Please enable',
    screenOff: 'Power-intensive prompt and Keep running after screen off',
    additional: 'Additional Settings',
    powerSaving: 'Manage apps battery usage and here: <br /> 1. Switch Power Saving Modes to Off <br /> 2. Choose the next options: Saving Power in The Background > Apps > Sweatcoin > Background Settings > No restrictions',
    autostart2: 'Autostart',
    permissions: 'Permissions',
    turnOn: 'Turn ON for “Sweatcoin”',
    bgActivity: 'Enable background activity',
    launch: 'Launch Sweatcoin',
    home: 'Press Home button',
    applist: 'Open your App list (recent apps, square or three-line button)',
    pull: 'Pull the Sweatcoin App preview slightly down to reveal two buttons above it',
    lock2: 'Press “Lock”',
});
const CardsBattery = [
    {
        screenshot: scr1,
        description: _jsx(FormattedMessage, Object.assign({}, messages.card1)),
    },
    {
        screenshot: scr2,
        description: _jsx(FormattedMessage, Object.assign({}, messages.card2)),
    },
    {
        screenshot: scr3,
        description: _jsx(FormattedMessage, Object.assign({}, messages.card3)),
    },
    {
        screenshot: scr4,
        description: _jsx(FormattedMessage, Object.assign({}, messages.card4)),
    },
    {
        screenshot: scr5,
        description: _jsx(FormattedMessage, Object.assign({}, messages.card5)),
    },
];
const CardsAutostart = [
    {
        screenshot: scr6,
        description: _jsx(FormattedMessage, Object.assign({}, messages.card6)),
    },
];
const CardsRecent = [
    {
        screenshot: scr7,
        description: _jsx(FormattedMessage, Object.assign({}, messages.card7)),
        top: '-35%',
    },
    {
        screenshot: scr8,
        description: _jsx(FormattedMessage, Object.assign({}, messages.card8)),
        top: '-35%',
    },
    {
        screenshot: scr9,
        description: _jsx(FormattedMessage, Object.assign({}, messages.card9)),
        top: '-35%',
    },
];
let trackedEvents = [];
const Xiaomi = (props) => {
    const { openSettings, trackEvent } = props;
    const sliderSettings = {
        dots: true,
        infinite: false,
        speed: 280,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    useEffect(() => {
        // cleanup
        return () => {
            trackedEvents = [];
        };
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(Title, { trackEvent: props.trackEvent, children: _jsx(FormattedMessage, Object.assign({}, messages.manage)) }), _jsx(SliderBlock, { trackedEvents: trackedEvents, trackEvent: trackEvent, index: 0, settings: sliderSettings, cardArray: buildArray(CardsBattery), cards: CardsBattery }), _jsx(SettingsButton, { openSettings: openSettings, style: { marginTop: '16px', marginBottom: '16px' }, children: _jsx(FormattedMessage, Object.assign({}, messages.settings)) }), _jsx(Divider, {}), _jsx(Title, { trackEvent: props.trackEvent, children: _jsx(FormattedMessage, Object.assign({}, messages.autostart)) }), _jsx(SliderBlock, { trackedEvents: trackedEvents, trackEvent: trackEvent, index: 0, settings: sliderSettings, cardArray: buildArray(CardsAutostart), cards: CardsAutostart }), _jsx(SettingsButton, { openSettings: openSettings, style: { marginTop: '16px', marginBottom: '16px' }, children: _jsx(FormattedMessage, Object.assign({}, messages.settings)) }), _jsx(Divider, {}), _jsx(Title, { trackEvent: props.trackEvent, children: _jsx(FormattedMessage, Object.assign({}, messages.lock)) }), _jsx(SliderBlock, { trackedEvents: trackedEvents, trackEvent: trackEvent, index: 0, settings: sliderSettings, cardArray: buildArray(CardsRecent), cards: CardsRecent }), _jsx(SettingsButton, { openSettings: openSettings, style: { marginTop: '16px', marginBottom: '16px' }, children: _jsx(FormattedMessage, Object.assign({}, messages.settings)) }), _jsx(Divider, {}), _jsx(Title, { style: { marginTop: '32px', marginBottom: '16px' }, children: _jsx(FormattedMessage, Object.assign({}, messages.alternative)) }), _jsx(Common, { featureAccelerometerTracker: props.featureAccelerometerTracker, trackEvent: props.trackEvent, openSettings: props.openSettings, isFooterDividerDefault: true }), _jsx(Title, { trackEvent: props.trackEvent, children: _jsx(FormattedMessage, Object.assign({}, messages.remove)) }), _jsxs(List, { children: [_jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.security)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.battery)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.appBattery)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.sweatcoin)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.noRestriction)) })] }), _jsx(Text, { children: _jsx(FormattedMessage, Object.assign({}, messages.alternative)) }), _jsxs(List, { children: [_jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.settings2)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.performance)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.manageApps)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.apps)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.sweatcoin)) }), _jsxs(ListItem, { children: [_jsx(FormattedMessage, Object.assign({}, messages.bgSettings)), ' ', props.featureAccelerometerTracker ? '' : _jsx(FormattedMessage, Object.assign({}, messages.andAllow))] })] }), _jsx(SettingsButton, { openSettings: props.openSettings, style: { marginTop: '16px', marginBottom: '16px' } }), _jsx(Divider, {}), _jsx(Title, { trackEvent: props.trackEvent, children: _jsx(FormattedMessage, Object.assign({}, messages.adjust)) }), _jsxs(List, { children: [_jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.settings2)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.advanced)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.batManager)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.setPower)) })] }), _jsx(Text, { children: _jsx(FormattedMessage, Object.assign({}, messages.alternative)) }), _jsxs(List, { children: [_jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.settings2)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.advanced)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.batManager)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.protected)) })] }), _jsx(SettingsButton, { openSettings: props.openSettings, style: { marginTop: '16px', marginBottom: '16px' } }), _jsx(Divider, {}), _jsx(Title, { trackEvent: props.trackEvent, children: _jsx(FormattedMessage, Object.assign({}, messages.enable)) }), _jsxs(List, { children: [_jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.settings2)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.apps)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.sweatcoin)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.battery)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.screenOff)) })] }), _jsx(Text, { children: _jsx(FormattedMessage, Object.assign({}, messages.alternative)) }), _jsxs(List, { children: [_jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.settings2)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.additional)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.performance)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.powerSaving)) })] }), _jsx(SettingsButton, { openSettings: props.openSettings, style: { marginTop: '16px', marginBottom: '16px' } }), _jsx(Divider, {}), _jsx(Title, { trackEvent: props.trackEvent, children: _jsx(FormattedMessage, Object.assign({}, messages.autostart2)) }), _jsxs(List, { children: [_jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.settings2)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.permissions)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.autostart2)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.turnOn)) })] }), _jsx(SettingsButton, { openSettings: props.openSettings, style: { marginTop: '16px', marginBottom: '16px' } }), _jsx(Divider, {}), _jsx(Title, { trackEvent: props.trackEvent, children: _jsx(FormattedMessage, Object.assign({}, messages.bgActivity)) }), _jsxs(List, { children: [_jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.launch)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.home)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.applist)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.pull)) }), _jsx(ListItem, { children: _jsx(FormattedMessage, Object.assign({}, messages.lock2)) })] }), _jsx(SettingsButton, { openSettings: props.openSettings, style: { marginTop: '16px', marginBottom: '16px' } }), _jsx(SamsungDivider, {}), _jsx(Footer, { featureAccelerometerTracker: props.featureAccelerometerTracker, trackEvent: props.trackEvent }), _jsx(AdviceNotSuitable, { trackEvent: props.trackEvent })] }));
};
const Card = styled.div `
  padding: 16px 0;
  width: calc(100% - 32px) !important;
  margin: 0 16px 0 0;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.1);
  outline: none;
  position: relative;
`;
const CardImage = styled.div `
  width: calc(100% - 64px);
  max-width: 264px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
`;
const Screenshot = styled.img `
  position: absolute;
  top: ${(props) => props.top};
  left: 0;
  width: 100%;
`;
const ScreenshotWrapper = styled.div `
  position: absolute;
  top: 9%;
  left: 16.2%;
  width: 68%;
  bottom: 1px;
  border-radius: 10px 10px 0 0;
  overflow: hidden;
`;
const Placeholder = styled.img `
  width: 100%;
  position: relative;
`;
const renderCard = (index, { src, top = 0 }) => (_jsx(Card, { children: _jsxs(CardImage, { children: [_jsx(ScreenshotWrapper, { children: _jsx(Screenshot, { src: src, top: top }) }), _jsx(Placeholder, { src: placeholderSrc })] }) }, index));
const buildArray = (cards) => cards.map((card, index) => renderCard(index, { src: card.screenshot, top: card.top || 0 }));
export default Xiaomi;
